import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  caseId: "",
  lobName: "",
  caseDescriptions: "",
  isAllocatedCase: false,
  reassignTo: "",
  index: 0,
  claimNo: "",
  selectedCase: null,
  closureCategory: null,
  sub_product:null,
};
export const CaseDescriptionSlice = createSlice({
  name: "Case_ID",
  initialState,
  reducers: {
    storeCaseId: (state, action) => {
      state.caseId = action?.payload?.colValue;
      state.lobName = action?.payload?.lobName;
      state.index = action?.payload?.index;
      state.sub_product= action?.payload?.sub_product;
    },
    storeClaimNo: (state, action) => {
      state.claimNo = action?.payload;
    },
    setClosureCategory: (state, action) => {
      state.closureCategory = action.payload;
    },
    storeAllCaseDescriptions: (state, action) => {
      state.caseDescriptions = action.payload;
    },
    storeIsAllocatedCase: (state, action) => {
      state.isAllocatedCase = action.payload;
    },
    storeReAssignTo: (state, action) => {
      state.reassignTo = action.payload;
    },
    storeSelectedCase: (state, action) => {
      state.selectedCase = action.payload;
    },
  },
});

export const {
  storeCaseId,
  storeAllCaseDescriptions,
  storeIsAllocatedCase,
  storeReAssignTo,
  storeClaimNo,
  storeSelectedCase,
  setClosureCategory,
} = CaseDescriptionSlice.actions;
export default CaseDescriptionSlice.reducer;
